import PrivacyModel from './privacy-model';
import PrivacyView from './privacy-view';
import * as UIService from '../../services/ui-service';

export default class PrivacyPresenter {
  constructor(view, appInterface) {
    this.model = new PrivacyModel();
    this.view = view || new PrivacyView();
    this.appInterface = appInterface || {};
  }

  async init() {
    this.renderPageContent();
    this.setupEventListeners();
  }

  renderPageContent() {
    const pageData = this.model.getPageData();
    const policyContent = this.model.getPolicyContent();
    
    this.view.renderPageHeader(pageData);
    this.view.renderContent(policyContent);
    
    this.appInterface.reinitTooltips();
  }

  setupEventListeners() {
    this.view.setupBackButtonEventListener(() => this.handleBackClick());
  }

  handleBackClick() {
    this.appInterface.navigateBack();
  }

  cleanup() {
    this.view.cleanup();
  }
}